import React from 'react'
import { Contributions } from 'Utilities/Plans/ContributionCalculator'
import { AncillaryMemberPremium, TieredRates } from 'Utilities/pharaoh.types'
import PlanTitle from '../plan-subcomponents/PlanTitle'
import { Label } from 'Utilities/config'
import styles from '../ERSupplementalPlans/index.module.scss'
import Plan, { PlanBody } from '../plan-subcomponents/Plan'
import { useToggle } from 'react-use'
import { isEmployerProps, EmployerProps } from '../plan-subcomponents/PremiumBreakdown'
import EREERate from '../ERSupplementalPlans/ERSupplementalSubComp/EREERate'
import BenifitAmountComp from '../ERSupplementalPlans/ERSupplementalSubComp/BenifitAmountComp'
import PeriodComp from '../ERSupplementalPlans/ERSupplementalSubComp/PeriodComp'
import { GlobalStringConstant } from 'GlobalStringConstant'
import { LifeERPlan } from '../LifePlan/index.helpers'
import { Group } from 'Utilities/Hooks/useStargate'
import TotalRate from '../ERSupplementalPlans/ERSupplementalSubComp/TotalRate'

interface Props {
  plan: { rate: TieredRates, plan: LifeERPlan, isRenewal: boolean, memberPremiums?: AncillaryMemberPremium }
  contributions: Contributions
  selected?: boolean
  selectHandler?(plan: LifeERPlan): void
  label: Label
  stargateGroup?: Group
  showWeeklyPayments: boolean
  showModal: boolean
}

const LifeER: React.FC< EmployerProps & Props> = (props) => {
  const { plan, selected, selectHandler, label, showWeeklyPayments, contributions, stargateGroup } = props
  const [showMemberPremiums, toggleShowMemberPremiums] = useToggle(false)
  const sbc = plan.plan.data.sbc
  const dollarAmount = plan.plan.data.benefitAmount.split(' ')[0].substring(1)
  const benefitAmountDescriptor = plan.plan.data.benefitAmount.split(/(?<=^\S+)\s/)[1]
  return <Plan selected={!!selected}>

    <PlanTitle
      {...plan}
      id={plan.plan.id}
      planName={plan.plan.name}
      carrier={plan.plan.carrier}
      selected={selected}
      selectHandler={selectHandler && (() => selectHandler(plan.plan))}
      includesProsperBenefits={false}
      planType={plan.plan.type}
      label={label}
      stargateGroup={stargateGroup}
      sbc={sbc}
      members={props.members}
      ancillaryMemberPremiums={plan.memberPremiums}
      needsMemberPremiumsShown={true}
      showMemberPremiums={showMemberPremiums}
      toggleShowMemberPremiums={toggleShowMemberPremiums}
      showModal={props.showModal}
    />
    <PlanBody planType={plan.plan.type}>
      {breakdown()}
      <BenifitAmountComp name={GlobalStringConstant[0].benefit_amount} benifitAmount={dollarAmount} benifitLabel={benefitAmountDescriptor}/>
      <div className={`${styles.endSection} ${styles.fourSpecs} ${styles.halfHeight}`}>
        <PeriodComp compName={GlobalStringConstant[0].accidental_death_and_dismemberment} daysOrWeak={plan.plan.data.accidentalDeathAndDismemberment} label={' '}/>
        <PeriodComp compName={GlobalStringConstant[0].conversion} daysOrWeak={plan.plan.data.conversion} label={' '}/>
      </div>
      <div className={styles.planDescFooter}>
        <p><span>*</span>All eligible employees must enroll in Group Life</p>
      </div>
    </PlanBody>
  </Plan>

  function breakdown() {
    const base = { plan, contributions, showWeeklyPayments }
    if (isEmployerProps(props)) {
      return <div className={`${styles.beginningSection} ${styles.fourSpecs} ${styles.halfHeight}`}><EREERate {...base} members={props.members}/><TotalRate {...base}/></div>
    }
  }
}

export default LifeER
